var map = {
	"./72/compose-email.svg": 6554,
	"./add-candidates.svg": 3055,
	"./additional-form.svg": 91749,
	"./arrow-down-sml.svg": 68196,
	"./arrow-right-sml.svg": 98654,
	"./arrow-up-sml.svg": 71019,
	"./at.svg": 29708,
	"./ats-sidebar.svg": 12470,
	"./attachment.svg": 2396,
	"./attention-circle.svg": 5380,
	"./avatar-full.svg": 48304,
	"./back.svg": 45354,
	"./bell-active.svg": 78229,
	"./bell-filled.svg": 28867,
	"./bin-full.svg": 92912,
	"./bin.svg": 37128,
	"./boost-large.svg": 11708,
	"./boost.svg": 43994,
	"./bot-conversation.svg": 94534,
	"./bot.svg": 73428,
	"./branch.svg": 95967,
	"./briefcase.svg": 46539,
	"./bulk-move-pipeline.svg": 37538,
	"./calendar.svg": 89485,
	"./candidate-color.svg": 854,
	"./candidate.svg": 96092,
	"./candidates-moved.svg": 79999,
	"./candidates.svg": 86233,
	"./chart-pie.svg": 83514,
	"./clock-full.svg": 18231,
	"./clock-rewind.svg": 41081,
	"./clock.svg": 46117,
	"./cog-filled.svg": 30865,
	"./cog.svg": 422,
	"./cogs-dual.svg": 33404,
	"./collect.svg": 26137,
	"./comments.svg": 64569,
	"./company.svg": 4758,
	"./content.svg": 97708,
	"./cross-bold.svg": 23943,
	"./cross-c-f.svg": 5694,
	"./cross.svg": 89679,
	"./crown.svg": 85706,
	"./cv.svg": 15316,
	"./dashboard.svg": 38267,
	"./drag-dots.svg": 50328,
	"./drag-drop.svg": 60107,
	"./drag-handle.svg": 71530,
	"./drag-stripes.svg": 76076,
	"./duplicate.svg": 92960,
	"./eb-sidebar.svg": 65241,
	"./eb-visits.svg": 77193,
	"./edit-form.svg": 86888,
	"./email-sent.svg": 94592,
	"./email.svg": 82799,
	"./emails_filled.svg": 86890,
	"./empty-state-plant.svg": 27728,
	"./envelope_filled.svg": 62740,
	"./event.svg": 33327,
	"./eye.svg": 32508,
	"./file-folder.svg": 77392,
	"./first.svg": 14605,
	"./form-answer.svg": 87538,
	"./form-filled.svg": 6748,
	"./form.svg": 22245,
	"./forms-dual.svg": 36331,
	"./forms.svg": 12174,
	"./forward-arrow.svg": 75496,
	"./forward.svg": 23604,
	"./freeform-text.svg": 97639,
	"./funnel.svg": 40803,
	"./gear.svg": 18978,
	"./globe-magnify.svg": 10882,
	"./grab.svg": 54089,
	"./hand.svg": 74224,
	"./happy-face.svg": 19871,
	"./heart.svg": 9499,
	"./help.svg": 22178,
	"./history.svg": 68759,
	"./image.svg": 11100,
	"./images.svg": 99961,
	"./info-f-c.svg": 93966,
	"./interview.svg": 58778,
	"./job-bag.svg": 77931,
	"./job-created.svg": 44397,
	"./job-f.svg": 20891,
	"./job-list.svg": 96621,
	"./job-views.svg": 54935,
	"./jobibot-color.svg": 48600,
	"./jobibot-sad.svg": 85726,
	"./jobibot-text.svg": 89324,
	"./jobibot.svg": 28766,
	"./jobilla-dashboard.svg": 21147,
	"./jobilla-logo-grayscale-flat.svg": 18386,
	"./jobilla-logo-grayscale.svg": 4192,
	"./jobilla-text-color-logo.svg": 88402,
	"./jobilla-text-logo.svg": 31752,
	"./landing-page.svg": 42008,
	"./last.svg": 47927,
	"./link-new-tab.svg": 93308,
	"./link-to-website.svg": 34625,
	"./link-url.svg": 65663,
	"./link.svg": 5975,
	"./location-f.svg": 17559,
	"./lock.svg": 97254,
	"./login.svg": 5588,
	"./logo-j.svg": 38459,
	"./logout.svg": 54365,
	"./magic-wand.svg": 56407,
	"./magnifying-glass.svg": 52659,
	"./mail.svg": 80566,
	"./manage-teams.svg": 40435,
	"./megaphone-f.svg": 12028,
	"./megaphone.svg": 94709,
	"./message-bubble.svg": 84911,
	"./message.svg": 30142,
	"./multi-choice.svg": 80109,
	"./new-document.svg": 5311,
	"./next.svg": 82168,
	"./no-search-result.svg": 13023,
	"./notes.svg": 71092,
	"./notification-bell.svg": 94842,
	"./on-off.svg": 33872,
	"./open-link.svg": 93146,
	"./padlock.svg": 25577,
	"./paper-write.svg": 60603,
	"./pencil.svg": 70668,
	"./people-join-pipeline.svg": 15486,
	"./people-moved-pipeline.svg": 89217,
	"./phone.svg": 20739,
	"./play-circle.svg": 82104,
	"./plus-circle.svg": 93534,
	"./plus.svg": 14711,
	"./pool.svg": 28029,
	"./previous.svg": 34116,
	"./progress-donut.svg": 98926,
	"./refresh.svg": 81370,
	"./sad-face.svg": 94425,
	"./save.svg": 48700,
	"./send-email.svg": 42274,
	"./send.svg": 25981,
	"./sent.svg": 36525,
	"./seo.svg": 79336,
	"./settings-emails.svg": 67056,
	"./settings-f.svg": 14321,
	"./settings-integrations.svg": 82290,
	"./settings-talents.svg": 13926,
	"./settings-users.svg": 94407,
	"./setup-finalization.svg": 43351,
	"./single-choice.svg": 10231,
	"./social-medias.svg": 54930,
	"./speech-bubble.svg": 27306,
	"./star-filled.svg": 88926,
	"./star-outline.svg": 21682,
	"./stopsign.svg": 73624,
	"./structure.svg": 13156,
	"./style.svg": 56036,
	"./subitem-branch.svg": 61419,
	"./subitem-last.svg": 27179,
	"./success-tag.svg": 10761,
	"./talent-email.svg": 98906,
	"./talent-moved.svg": 87755,
	"./talent-new.svg": 96836,
	"./talent-pool-sidebar.svg": 42673,
	"./talent-removed.svg": 20734,
	"./talent.svg": 61109,
	"./talents-email.svg": 16905,
	"./talents-moved.svg": 90164,
	"./talents-removed.svg": 38449,
	"./talents.svg": 6334,
	"./te-palvelut.svg": 30382,
	"./team.svg": 64928,
	"./teams-avatar.svg": 59311,
	"./teams.svg": 90533,
	"./text-field.svg": 76497,
	"./thumb-tag.svg": 47828,
	"./tick-circle.svg": 54899,
	"./tick-sml.svg": 5095,
	"./tick-square.svg": 37830,
	"./tick.svg": 48612,
	"./trash-bin.svg": 85413,
	"./upload.svg": 8016,
	"./user-avatar.svg": 7642,
	"./video.svg": 68634,
	"./warning-f.svg": 56358,
	"./warning.svg": 53547,
	"./web.svg": 96517,
	"./webpage.svg": 62708,
	"./wrench.svg": 41504,
	"./xmas-jobibot-text.svg": 5978,
	"./xmas-jobibot.svg": 78832,
	"./xmas-jobilla-dashboard.svg": 90717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40707;